<label class="subHeading"
  >Plan Name<span *ngIf="isRequired" class="star">*</span></label
>
<app-search-dropdown
  [dataSearchKey]="'plan_name'"
  [dataValueKey]="'plan_name'"
  [dataSource]="plan_name"
  [control]="plannameControl"
></app-search-dropdown>
